<style>
#addScadaPointModal .v--modal-box.v--modal {
  min-width: 650px !important;
  min-height: 320px !important;
}
#addScadaPointModal .modal__content {
  overflow-y: auto !important;
}
#addScadaPointModal .btn__subheader {
  opacity: 0.4;
  line-height: 40px;
  transition: all 0.2s;
  line-height: 16px;
  margin-left: 5px;
  margin-bottom: 10px;
}
#addScadaPointModal .btn__subheader:hover {
  opacity: 1;
  cursor: pointer;
}
#addScadaPointModal
  .v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  justify-content: center !important;
}
.measuring-series-props--element {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.measuring-series-props--element:not(:last-child) {
  border-bottom: 1px solid lightgrey;
}
.measuring-series-props--element > span {
  flex: 0 0 25%;
  text-align: center;
}
.element-title {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
#addScadaPointModal .v-text-field__slot input,
#addScadaPointModal .v-label.theme--light {
  font-size: 12px !important;
}
#addScadaPointModal .measuring-series-props--element > span {
  flex: 0 0 14.28% !important; /* 14.28% -> 7 elementów w tabeli */
}
#addScadaPointModal .v-list__tile__action,
.v-list__tile__avatar {
  min-width: none !important;
}
#addScadaPointModal .modal__content .container {
  padding-bottom: 0;
}
</style>

<template>
  <Modal
    modalName="addScadaPointModal"
    :title="modalTitle"
    :module="module"
    :buttons="['save']"
    @saved="modifyScadaPoint"
    @opened="opened"
    @closed="closed"
  >
    <v-container>
      <v-subheader class="first-subheader font--primary">Dane punktu pomiarowego</v-subheader>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            v-model="pointName"
            id="pointName"
            label="Nazwa punktu"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            v-model="pointCode"
            id="pointCode"
            label="Kod punktu"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-text-field
          v-model="pointDescription"
          id="pointDescription"
          label="Opis punktu"
        ></v-text-field>
      </v-flex>
      <v-layout
        row
        wrap
      >
        <v-subheader class="first-subheader font--primary">Serie pomiarowe</v-subheader>
        <v-icon
          class="btn__subheader"
          title="Dodaj serię pomiarową"
          style="font-size: 16px !important;"
          @click="show('addMeasuringSeriesModal')"
          :disabled="!pointID"
        >add_circle_outline</v-icon>
        <v-flex xs12>
          <p
            v-if="!pointID"
            class="font--primary"
          >Przed dodaniem serii pomiarowej należy zapisać nowy punkt pomiarowy.</p>
          <span v-else>
            <div v-if="Object.keys(measuringSeriesProps).length > 0">
              <ul>
                <li class="measuring-series-props--element">
                  <span class="element-title font--primary">Nazwa pomiaru</span>
                  <span class="element-title font--primary">Typ serii pomiarowej</span>
                  <span class="element-title font--primary">Parametr</span>
                  <span class="element-title font--primary">Jednostka pomiaru</span>
                  <span class="element-title font--primary">Wyświetlaj</span>
                  <span class="element-title font--primary">Edytuj</span>
                  <span class="element-title font--primary">Usuń</span>
                </li>
                <li
                  class="measuring-series-props--element font--primary"
                  v-for="(val, key) in measuringSeriesProps"
                  :key="key"
                >
                  <span v-text="val.name"></span>
                  <span v-text="val.measure_type"></span>
                  <span v-text="val.parameter"></span>
                  <span v-text="val.unit"></span>
                  <v-list-tile-action style="flex: 0 0 14.28%; text-align: center;">
                    <v-checkbox v-model="val.visible"></v-checkbox>
                  </v-list-tile-action>
                  <v-icon
                    @click="editMeasuringSeries(measuringSeriesProps[key], key)"
                    style="flex: 0 0 14.28%; text-align: center;"
                  >edit</v-icon>
                  <v-icon
                    @click="removeMeasuringSeries(val, key)"
                    style="flex: 0 0 14.28%; text-align: center;"
                  >delete</v-icon>
                </li>
              </ul>
            </div>
            <div
              v-else
              class="font--primary"
            >Brak serii pomiarowych</div>
          </span>
        </v-flex>
        <v-flex
          xs12
          v-if="pointID"
        >
          <v-subheader
            class="first-subheader font--primary"
            style="margin-top: 40px;"
          >Ustawienia punktu pomiarowego</v-subheader>
          <v-btn
            style="margin-left: 0;width: 253px;"
            dark
            color="red"
            depressed
            @click="removeScadaPoint"
          >
            Usuń punkt pomiarowy
            <v-icon style="font-size:18px; margin-left: 25px;">delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
// import AddMeasuringSeries from "./AddMeasuringSeries";

export default {
  components: {
    // AddMeasuringSeries,
    Modal
  },
  props: {
    pointCoords: Array
  },
  data: () => ({
    pointName: undefined,
    module: "scada",
    pointCode: undefined,
    pointDescription: undefined,
    pointID: undefined,
    measuringSeriesProps: [],
    modalTitle: "a"
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    scadaPoints() {
      return this.$store.getters.getScadaPoints;
    },
    scadaFeatures() {
      return this.$store.getters.getScadaFeaturesArr;
    }
  },
  mounted() {
    this.$root.$on("sendScadaData", data => {
      this.pointName = data.name;
      this.pointCode = data.code;
      this.pointDescription = data.description;
      this.pointID = data.id;
      this.measuringSeriesProps = data.measures;
    });

    this.$root.$on("sendMeasuringDetails", this.updateProps);
  },
  methods: {
    editMeasuringSeries(series, key) {
      this.show("addMeasuringSeriesModal");
      this.$root.$emit("editSeries", [series, key]);
    },
    removeScadaPoint() {
      const self = this;
      this.$modal.show("dialog", {
        title: "Usuwanie punktu pomiarowego",
        text: "Czy na pewno chcesz usunąć punkt pomiarowy?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store
                .dispatch("removeScadaPoint", self.pointID)
                .then(success => {
                  if(!success) {
                    self.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania serii pomiarowej wystąpił błąd"
                    );
                  }
                });
              self.$emit("confDialogOpened", false);
              self.$root.$emit("removeScadaPoint");
              self.$modal.hide("dialog");
              self.$modal.hide("addScadaPointModal");
              self.$modal.hide("scadaPointCard");
            }
          }
        ]
      });
    },
    removeMeasuringSeries(measure, key) {
      const self = this;
      this.$modal.show("dialog", {
        title: "Usuwanie serii pomiarowej",
        text: "Czy na pewno chcesz usunąć serię pomiarową?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.measuringSeriesProps.splice(key, 1);
              let payload = {
                id: self.pointID,
                body: {
                  code: self.pointCode,
                  description: self.pointDescription,
                  name: self.pointName,
                  measures: self.measuringSeriesProps
                }
              };
              self.$store.dispatch("editScadaPoint", payload).then(success => {
                if(!success) {
                  self.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas usuwania serii pomiarowej wystąpił błąd"
                  );
                }
              });
              self.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    modifyScadaPoint() {
      const self = this;
      if(!this.pointID) {
        // dodawanie punktu
        let payload = {
          code: this.pointCode,
          description: this.pointDescription,
          geometry: {coordinates: this.pointCoords, type: "Point"},
          measures: this.measuringSeriesProps,
          name: this.pointName
        };

        this.$store.dispatch("addScadaPoint", payload).then(success => {
          if(typeof success.data.created != "number") {
            // when it's not a number == error
            if(success.data.message == "code_already_exists") {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Punkt o podanym kodzie już istnieje"
              );
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas dodawania punktu pomiarowego wystąpił błąd"
              );
            }
            return;
          } else {
            this.$root.$emit("newPointAdded", success.data.created);
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano punkt pomiarowy"
            );
            this.$emit("newScadaPoint", {
              pointName: payload.name,
              pointCode: payload.code,
              pointDescription: payload.description,
              pointID: success.data.created
            });
          }
        });
      } else {
        // edycja punktu
        let payload = {
          id: this.pointID,
          body: {
            code: this.pointCode,
            description: this.pointDescription,
            name: this.pointName,
            measures: this.measuringSeriesProps
          }
        };
        this.$store.dispatch("editScadaPoint", payload).then(success => {
          if(success) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dokonano edycji punktu pomiarowego"
            );
            self.$root.$emit("getPointData");
            self.$root.$emit("refreshPoint", payload);
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas edycji punktu pomiarowego wystąpił błąd"
            );
          }
        });
      }
      this.closed();
    },
    updateProps(value) {
      if(value[1] > -1) {
        this.measuringSeriesProps.splice(value[1], 1);
      }
      this.measuringSeriesProps.push(value[0]);
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    opened() {
      if(this.pointID) {
        this.modalTitle = "Edycja punktu pomiarowego";
      } else {
        this.modalTitle = "Dodawanie punktu pomiarowego";
      }
    },
    closed() {
      this.pointName = undefined;
      this.pointCode = undefined;
      this.pointDescription = undefined;
      this.pointID = undefined;
      this.measuringSeriesProps = [];
      this.$modal.hide("addScadaPointModal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/AddScadaPoint.vue